import React from 'react'
import { connect } from 'react-redux'
import injectSheet from 'react-jss'
import style from './style'
import { CSSTransition, TransitionGroup } from 'react-transition-group'
import AddButton from '../AddButton'
import PeripheralDevice from '../PeripheralDevice'
import { addPeripheralAction } from 'actions/entityActions'
import { ACCESS_USAGE_MAP, ACCESS_REVERSE_MAP } from 'helpers/globals'
import toTitle from 'helpers/accessControl/toTitle'

class PeripheralLimitGroup extends React.Component {
  fadeClasses = _ => {
    const { classes } = this.props

    return {
      appear: classes.fadeAppear,
      appearActive: classes.fadeAppearActive,
      appearDone: classes.fadeAppearDone,
      enter: classes.fadeEnter,
      enterActive: classes.fadeEnterActive,
      enterDone: classes.fadeEnterDone,
      exit: classes.fadeExit,
      exitActive: classes.fadeExitActive,
      exitDone: classes.fadeExitDone
    }
  }

  addHeight = node => {
    node.style.overflow = 'hidden'
    node.style.height = `${node.scrollHeight}px`
    node.style.overflow = ''
  }
  clearHeight = node => node.style.height = null

  transitionProps = _ => ({
    timeout: 200,
    onExit: this.addHeight,
    onExiting: this.clearHeight,
    onEntering: this.addHeight,
    onEntered: this.clearHeight,
    classNames: this.fadeClasses(),
    unmountOnExit: true
  })

  render() {
    const { transitionProps, props: { limitType, currentDoor, model, usages, totals, style, addPeripheralAction, classes } } = this

    return (
      <div className={classes.wrapper} style={style}>
        { ACCESS_REVERSE_MAP[limitType].length > 1 &&
          <div className={classes.container}>
            <span className={classes.header}>
              {toTitle(limitType)}
            </span>
          </div>
        }
        { ACCESS_REVERSE_MAP[limitType].map(peripheralType =>
            <div className={classes.container} key={peripheralType}>
              <span className={classes.label}>
                {toTitle(peripheralType)}:
              </span>
              <AddButton
                disabled={usages[ACCESS_USAGE_MAP[peripheralType]] >= model.limits[ACCESS_USAGE_MAP[peripheralType]] || (totals.show && totals.usages[ACCESS_USAGE_MAP[peripheralType]] >= totals.limits[ACCESS_USAGE_MAP[peripheralType]])}
                count={currentDoor[peripheralType].length}
                onClick={_ => addPeripheralAction(peripheralType, currentDoor.id)}
                title={`${model.text} cannot add more ${toTitle(ACCESS_USAGE_MAP[peripheralType])}`}
              />
              <TransitionGroup style={{ width: '100%' }}>
                { currentDoor[peripheralType].map(peripheralId =>
                    <CSSTransition { ...transitionProps() } key={peripheralId}>
                      <PeripheralDevice
                        peripheralType={peripheralType}
                        peripheralId={peripheralId}
                        doorId={currentDoor.id}
                      />
                    </CSSTransition>
                  )
                }
              </TransitionGroup>
            </div>
          )
        }
      </div>
    )
  }
}

export default connect(null, { addPeripheralAction })(injectSheet(style)(PeripheralLimitGroup))



// WEBPACK FOOTER //
// ./src/components/DoorControllerDesigner/DoorConfiguration/PeripheralLimitGroup/index.js